if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('fostr-cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('fostr-cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.dataset.cartType != 'page') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          document.dispatchEvent(new Event('cart-item:added'));
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.checkMaxItem();
        });
    }

    checkMaxItem() {
      const quantityProductInput = document.querySelector('.product__info-wrapper .quantity__input');
      const quantityCartItems = document.querySelectorAll('.cart-items .quantity__input');

      if (quantityCartItems.length > 0) {
        quantityCartItems.forEach(quantityInput => {
          if (quantityInput.hasAttribute('data-max-item-id')) {
            if (quantityInput.dataset.maxItemId === quantityProductInput.dataset.maxItemId){
              let newMax = quantityProductInput.dataset.max - quantityInput.value;
              quantityProductInput.value = 1;
              quantityProductInput.dataset.max = newMax;
              if (newMax <= 0) {
                document.querySelector('form .product-form__submit').disabled = true; 
                quantityProductInput.dataset.maxReached = '';
              } else {
                document.querySelector('form .product-form__submit').disabled = false;
                quantityProductInput.removeAttribute('data-max-reached');

              }
            }
          }
        })
      }

      if (document.querySelector('.quantity__input').hasAttribute('data-max-reached')) {
        document.querySelector('form .product-form__submit').disabled = true;
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

// Recharge Subscription

var rcRadioOption = document.querySelector('#rc_radio_options');
if (rcRadioOption) {
  let rechargeTimer = setInterval(() => {
      clearInterval(rechargeTimer);
      const rcBlocks = rcRadioOption.querySelectorAll('.rc_block.rc_block__type');

      const subscription_buttons = document.querySelectorAll('.recharge-subscription .recharge-subscription--item');
      subscription_buttons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();

          subscription_buttons.forEach(rmEl => {
            const rm_span = rmEl.querySelector('span');
            rm_span.classList.remove('checked');
          });

          const span = button.querySelector('span');
          const activeClass = `rc_block__type__${button.getAttribute('data-title')}`;
          span.classList.add('checked');

          const deliveryWidget = document.querySelector('.recharge-subscription .delivery_widget');
          if (button.getAttribute('data-title') == 'onetime') {
            deliveryWidget.classList.add('hidden');
          } else {
            deliveryWidget.classList.remove('hidden');
          }

          rcBlocks.forEach(block => {
            if (block.classList.contains(activeClass)) {
              const input = block.querySelector('input');
              input.click();
            }
          });
        });
      });

      const deliverySelect = document.querySelector('.recharge-subscription .delivery_select');
      const rechargeDeliverySelect = rcRadioOption.querySelector('#rc_autodeliver_options select');
      if (deliverySelect) {
        deliverySelect.addEventListener('change', (e) => {
          const value = e.target.value;
          if (rechargeDeliverySelect) {
            rechargeDeliverySelect.value = value;
          }
        });
      }
    
  }, 1000);

  setTimeout(() => {
    clearInterval(rechargeTimer);
  }, 20000);
  // Recharge Subscription

}